import { Alert, Flex } from '@/_components';
import type { FC } from 'react';
import type { QuestionNotApplicableProps } from './QuestionNotApplicable.types';

export const QuestionNotApplicable: FC<QuestionNotApplicableProps> = () => {
  return (
    <Flex isInline={true}>
      <Alert type="info" icon="info">
        You marked this question as not applicable to you.
      </Alert>
    </Flex>
  );
};
